import actions from 'redux/actions'
import { reducers, getState } from 'redux/core'
import { mixpanel, links, constants, snowplow } from 'common/helpers'


const setDate = (date) => reducers.view.giftPage.setDate(date)

const setGender = (gender) => reducers.view.giftPage.setGender(gender)

const setGiftSizes = (giftSizes) => reducers.view.giftPage.setGiftSizes(giftSizes)

/**
 * @param {object} data
 * @param {number} data.size
 * @param {number} data.price
 */
const setGiftParams = (data) => reducers.view.giftPage.setGiftParams(data)

/**
 * @param {object} data
 * @param {string} data.name
 * @param {string} data.email
 * @param {string} data.message
 */
const setPerson = (data) => reducers.view.giftPage.setPerson(data)

const reset = reducers.view.giftPage.reset


// Modals flow ------------------------------------------------------------ /

// helpers

/**
 * @description:
 * This function helps to open choose gift modals one after another.
 * @param {string} modalName
 * @param {object} modalData
 * @param {function} modalData.onNext
 * @param {function} modalData.onBack
 * @param {function} modalData.onPickDate
 */
const openModalWithData = (modalName, modalData) => {
  actions.models.modals.open(modalName, modalData)
}


// modals data objects
/**
 * @description:
 * This function starts the flow. We have a lot of abstract modals.
 * It is necessary to open them in turn. For each modal window, the parameters are specified.
 * @param {string} gender
 */
const startGetGiftFlow = (gender) => {
  setGender(gender)
  openChooseGiftSizeModal()
  snowplow.track(constants.snowplowEvents.buyGiftSubscriptionClick, {
    gender,
  }, false)
}

/**
 * @description:
 * Open choose gift size modal (first modal in the flow).
 */
const openChooseGiftSizeModal = () => {
  mixpanel.track('Gift continue')

  openModalWithData(constants.modals.gifts.ChooseGiftSize, {
    onNext: ({ size, price }) => {
      snowplow.track(constants.snowplowEvents.buyGiftSubscriptionStepComplete, {
        stepName: 'choose size',
        step: 1,
        plan: size,
        price: Number(price),
      })

      setGiftParams({ size, price })
      openSetGiftRecipientInfoModal()
    },
  })
}

/**
 * @description:
 * Open set gift recipient modal (second modal in the flow).
 */
const openSetGiftRecipientInfoModal = () => {
  openModalWithData(constants.modals.gifts.SetGiftRecipientInfo, {
    onNext: ({ name, email, message }) => {
      snowplow.track(constants.snowplowEvents.buyGiftSubscriptionStepComplete, {
        stepName: 'recipient',
        step: 2,
        email,
      })

      setPerson({ name, email, message })
      openSetGiftDateModal()
    },
    onBack: () => openChooseGiftSizeModal(),
  })
}

/**
 * @description:
 * Open choose gift size modal (third modal in the flow).
 */
const openSetGiftDateModal = () => {
  openModalWithData(constants.modals.gifts.SetGiftDate, {
    onNext: () => {
      setDate(null)

      const { view: { giftPage: gift } } = getState()

      snowplow.track(constants.snowplowEvents.buyGiftSubscriptionStepComplete, {
        stepName: 'choose date',
        step: 3,
        when: 'now',
      })

      actions.misc.cookies.setItem(constants.cookieNames.paymentGiftSubscription, gift)
      actions.models.router.push(links.giftSubscriptionPayment)
    },
    onBack: () => openSetGiftRecipientInfoModal(),
    onChooseSpecificDate: () => {
      snowplow.track(constants.snowplowEvents.buyGiftSubscriptionStepComplete, {
        stepName: 'choose date',
        step: 3,
        when: 'specific',
      })

      openPickDateModal()
    },
  })
}

/**
 * @description:
 * Open pick date gift modal (fourth modal in the flow).
 */
const openPickDateModal = () => {
  openModalWithData(constants.modals.PickDate, {
    onNext: () => {
      const { view: { giftPage: gift } } = getState()

      snowplow.track(constants.snowplowEvents.buyGiftSubscriptionStepComplete, {
        stepName: 'choose specific date',
        step: 4,
      })

      actions.misc.cookies.setItem(constants.cookieNames.paymentGiftSubscription, gift)
      actions.models.router.push(links.giftSubscriptionPayment)
    },
    onBack: () => openSetGiftDateModal(),
    onPickDate: (date) => setDate(date),
  })
}


export default {
  setGiftSizes,
  startGetGiftFlow,
  reset,
}
